import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerhuurdersverklaringAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="M10 34h20V12l-3.01-3.01L24 6H10v28"
      clipRule="evenodd"
    />
    <path
      fill="#6FBC85"
      fillRule="evenodd"
      d="m24 6 3 3 3 3h-6z"
      clipRule="evenodd"
    />
    <path
      fill="#6FBC85"
      d="M22 12.52H12v-1.05h10zm-1 1.95h-9v1.05h9zm1.71 8H12v1.05h10.71zm-4.71 3h-6v1.05h6z"
    />
    <path
      fill="#00A75D"
      d="m28.43 32-3.7-.01-4.44-11 3.71-1.5 2.6 6.44 4.7-11.45L35 16z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerhuurdersverklaringAanvragen);

export default ForwardRef;
